import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppComponent } from 'src/app/app.component';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { InputReporte, OutputReporteVerticalidad, OutputVistaInformacionGeneral, SeguridadSalida, VerticalidadDTO, ConceptoVerticalDetalle, Archivo, InputReporteVerticalidad } from 'src/app/modelo';
//import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api/selectitem';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-verticalidad',
    templateUrl: './verticalidad.component.html',
    //styleUrls: ['./verticalidad.component.css']
})
export class VerticalidadComponent implements OnInit {

    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public verticalidad: OutputReporteVerticalidad;
    public entity: VerticalidadDTO;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;
    public uploadedFiles: any[] = [];
    public btn_Disabled: boolean;

    //@ViewChild('table')
    //public pTable: Table;
    //public index: number = 1;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        console.log('VerticalidadComponent -->> ', new Date());

    }

    /**
     * 
     */
    public async ngOnInit() {
        this.entity = <VerticalidadDTO>{};
        this.verticalidad = <OutputReporteVerticalidad>{ listaVerticalidad: [] };
    }

    /**
     * 
     */
    public async init() {
        await this.loading();
    }

    /**
     * 
     */
    public async loading() {

        this.btn_Disabled = true;

        this.entity = <VerticalidadDTO>{};

        this.verticalidad = <OutputReporteVerticalidad>{ listaVerticalidad: [] };

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteVerticalidad> = await this.service.ObtenerReporteVerticalidad(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.verticalidad = resultado.model;

            if (this.verticalidad.listaVerticalidad != null && this.verticalidad.listaVerticalidad.length > 0) {

                this.entity = this.verticalidad.listaVerticalidad[0];

                for (let row of this.verticalidad.listaVerticalidad) {

                    if (row.fechaColadoPrimerNivel != null) {
                        row.fechaColadoPrimerNivel = new Date(row.fechaColadoPrimerNivel);
                        row.fechaColadoPrimerNivel_TMP = new Date(row.fechaColadoPrimerNivel);
                    }

                    row.cumpleTotalViviendas_TMP = row.cumpleTotalViviendas;
                    row.viviendasConstruidas_TMP = row.viviendasConstruidas;
                    row.nivelesHabitables_TMP = row.nivelesHabitables;
                    row.foto_TMP = row.foto;
                    row.actualizado = false;

                    for (let item of row.listaConceptoVerticalDetalle) {
                        item.ejecutado_TMP = item.ejecutado;
                        item.actualizado = false;
                    }

                    
                }

                this.btn_Disabled = false;
            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }
    }

    /**
     * 
     * @param entity
     * @param index
     */
    public onRowSelect(entity: VerticalidadDTO): void {

        this.entity = entity;
    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
    * 
    * @param entity
    */
    public onRowSelectVerticalidad(entity: any): void {

    }

    /**
     * 
     * @param entity
     */
    public onRowUnselectVerticalidad(entity: any): void {

    }

    /**
    * 
    */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
     * 
     */
    public getDateSpanish(): any {
        return Util.getDateSpanish();
    }

    /**
    * 
    */
    public async Guardar() {

        Util.showLoadingMessage(this.spinner, `Guardando información de reporte Verticalidad ...`);

        let listVerticalidad: VerticalidadDTO[] = [];

        let listConceptoVerticalDetalle: ConceptoVerticalDetalle[] = [];

        let listaVerticalidad: VerticalidadDTO[] = Util.clone(this.verticalidad.listaVerticalidad);

        for (let verticalidadDTO of listaVerticalidad) {


            let filtro = verticalidadDTO.listaConceptoVerticalDetalle.filter(row => row.actualizado == true);

            listConceptoVerticalDetalle.push(...filtro);


            if (verticalidadDTO.actualizado == true) {

                verticalidadDTO.listaConceptoVerticalDetalle = [];

                listVerticalidad.push(verticalidadDTO);
            }
           

        }

        let dato: InputReporteVerticalidad = <InputReporteVerticalidad>{ listaVerticalidad: listVerticalidad, listaConceptoVerticalDetalle: listConceptoVerticalDetalle };

        let resultado: JsonResponse<boolean> = await this.service.GuardarReporteVerticalidad(dato).toPromise();

        Util.hideLoadingMessage();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            let respuesta: boolean = resultado.model;

            if (respuesta == true) {

                var strCallback = (): void => {
                    this.Regresar();
                }

                let value = Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success', false, strCallback);
               
            } else {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
            }

        }
    }

    /**
     * 
     */
    public async DescargarReporte() {

    }

    /**
     * 
     * @param event
     * @param fileUpload
     */
    public async onFileUpload(event: { files: File }, fileUpload) {

        Util.showLoadingMessage(this.spinner, 'Procesando documento ...');

        var excelParametros = { opcion: 'Vivienda' };

        let resultado: JsonResponse<Archivo[]> = await this.service.AgregarDocumento(event, excelParametros).toPromise();

        Util.hideLoadingMessage();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            if (resultado.model.length > 0) {
                this.entity.foto = resultado.model[0].url;
                this.onChangeVerticalidad(this.entity);
            }

            console.log('resultado.model -->> ', resultado.model);

            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Documento guardado correctamente ...', 'success');

        } else {
            Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al guardar el documento ...', 'error');
        }

        fileUpload.clear();

    }

    /**
    * 
    * @param message
    */
    private showMessage(message: string) {
        AppComponent.message = message;
        this.spinner.show();
    }


    /**
     * 
     * @param index
     */
    public getListViviendasConstruidas(index: number): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let x = index; x <= 100; x++) {
            lista.push({ label: x + '', value: x })
        }

        return lista;
    }

    /**
     * 
     * @param index
     */
    public getListNivelesHabitables(index: number): SelectItem[] {

        let lista: SelectItem[] = [];

        for (let x = index; x <= 100; x++) {
            lista.push({ label: x + '', value: x })
        }

        return lista;
    }

    /**
     * 
     * @param entity
     */
    public onChangeConceptoVertical(entity: ConceptoVerticalDetalle): void {
        entity.actualizado = true;
        entity.conceptoVertical.ejecutado = entity.ejecutado;
    }

    /**
    * 
    * @param entity
    */
    public onChangeVerticalidad(entity: VerticalidadDTO): void {
        this.entity.actualizado = true;
    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeCumple(entity: VerticalidadDTO, value: number): void {
        entity.actualizado = true;
        entity.cumpleTotalViviendas = value;
    }

    /**
     * 
     * @param entity
     */
    public getDisabled(entity: ConceptoVerticalDetalle): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus != 0) {
            resultado = true;
        }

        if (entity.ejecutado_TMP == true) {
            resultado = true;
        }

        return resultado;
    }
}



